import type { ComponentProps } from 'react'

import { ICON_DEFAULT_COLOR, ICON_DEFAULT_FILL, type IconProps } from 'components'

export const Eraser = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = '24', // TODO: Replace with ICON_DEFAULT_WIDTH when migration to ION is complete
  height = '24', // TODO: Replace with ICON_DEFAULT_HEIGHT when migration to ION is complete
  viewBox = '0 0 24 24', // TODO: Replace with ICON_DEFAULT_VIEWBOX when migration to ION is complete
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.7723 3.16984C13.0395 1.90262 15.0181 1.85224 16.2332 3.16984L21.8328 8.76945C23.1001 10.0367 23.1506 12.0153 21.8328 13.2304L14.8133 20.2499H22.0027C22.4169 20.2499 22.7526 20.5858 22.7527 20.9999C22.7527 21.4141 22.4169 21.7499 22.0027 21.7499H7.00272C6.80388 21.7499 6.61306 21.6708 6.47245 21.5302L2.17265 17.2304C0.905033 15.9628 0.854778 13.9835 2.17362 12.7685L11.7723 3.16984ZM3.23319 13.83C3.22398 13.8392 3.21456 13.8486 3.20487 13.8573C2.5523 14.4447 2.50969 15.4463 3.23319 16.1698L7.31327 20.2499H12.6922L12.9422 19.9999L5.00272 12.0605L3.23319 13.83ZM15.1453 4.20207C14.558 3.5495 13.5563 3.50689 12.8328 4.23039L6.06327 10.9999L14.0027 18.9394L20.7723 12.1698L20.8016 12.1425C21.4539 11.5552 21.4957 10.5534 20.7723 9.83L15.1726 4.23039C15.1634 4.22111 15.1541 4.21182 15.1453 4.20207Z"
        fill={color}
      />
    </svg>
  )
}
